import EmojiPicker from '../EmojiPicker/EmojiPicker'

const EmojiOption = (props: any) => {
  const stopPropagation = (event: any) => {
    event.stopPropagation()
  }

  const onChange = (data: any) => {
    props.onChange(data.native)
    props.doCollapse()
  }

  const renderModal = () => {
    return (
      <div onClick={stopPropagation} className="rdw-emoji-modal">
        <EmojiPicker onSelect={onChange} useButton={false} />
      </div>
    )
  }

  return (
    <div
      aria-haspopup="true"
      aria-expanded={props.expanded}
      aria-label="rdw-link"
      className="rdw-link-wrapper"
    >
      <div
        onClick={props.onExpandEvent}
        className="rdw-option-wrapper markdown-toolbar-option"
      >
        <img src={props.config.icon} alt="" />
      </div>
      {props.expanded ? renderModal() : undefined}
    </div>
  )
}

export default EmojiOption
